var TimeUnit_1;
import { __decorate } from "tslib";
import { Unit } from './Unit';
import { SerializableObject } from '../../data/decorators';
import { UnitPrefix } from './UnitPrefix';
/**
 * @category Unit
 */
let TimeUnit = TimeUnit_1 = class TimeUnit extends Unit {};
TimeUnit.SECOND = new TimeUnit_1('second', {
  baseName: 'time',
  aliases: ['s', 'sec', 'seconds'],
  prefixes: 'decimal'
});
TimeUnit.MILLISECOND = TimeUnit_1.SECOND.specifier(UnitPrefix.MILLI);
TimeUnit.MICROSECOND = TimeUnit_1.SECOND.specifier(UnitPrefix.MICRO);
TimeUnit.NANOSECOND = TimeUnit_1.SECOND.specifier(UnitPrefix.NANO);
TimeUnit.MINUTE = new TimeUnit_1('minute', {
  baseName: 'time',
  aliases: ['m', 'min', 'minutes'],
  definitions: [{
    magnitude: 60,
    unit: 's'
  }]
});
TimeUnit.HOUR = new TimeUnit_1('hour', {
  baseName: 'time',
  aliases: ['h', 'hr', 'hrs', 'hours'],
  definitions: [{
    magnitude: 3600,
    unit: 's'
  }, {
    magnitude: 60,
    unit: 'min'
  }]
});
TimeUnit = TimeUnit_1 = __decorate([SerializableObject()], TimeUnit);
export { TimeUnit };